import { createSelector } from '@ngrx/store';
import { equipClassSelectors } from './equipment-class.state';
import { equipTypeSelectors } from './equipment-type.state';
import { selectEquipTypesVM } from './equipment-type.join-selectors';
import { EquipmentClassVM } from '@app/models';

export const currentEquipClassTypes = createSelector(
  equipClassSelectors.selectCurrentEntityKey,
  equipTypeSelectors.selectAll,
  (currentClassId, equipTypes) => {
    if (!currentClassId) {
      return [];
    }
    return equipTypes.filter(et => et.equipClass === currentClassId);
  }
);

export const equipmentClassVM = createSelector(
  selectEquipTypesVM,
  equipClassSelectors.selectAll,
  (equipTypes, equipClasses): EquipmentClassVM[] => {
    return equipClasses.map(eqCl => ({
      ...eqCl,
      equipmentTypes: equipTypes.filter(
        eqType => eqType.equipClass === eqCl.id
      ),
    }));
  }
);
